export const PREFORM = {
  en: {
    NAME: "155428205164207880",
    MOBILE: "155428205164203472",
    EMAIL: "155428205164205910",
    MSG: "155428205164207580"
  },
  ar: {
    NAME: "155335326768307115",
    MOBILE: "155335326768309489",
    EMAIL: "155335326768304823",
    MSG: "155335326768308335"
  }
};

const preFormKeys = language => {};

export const POSTFORM = {
  Q1: "155428216858607529",
  Q2: "15542821685860616",
  Q3: "155428216858607642"
};



// WEBPACK FOOTER //
// ./src/constants/livechatForms.js